import React, { Component } from 'react'
import { connect } from 'react-redux'

import StepButton from '../step-button/StepButton'
import BackButton from '../back-button/BackButton'
import ProgressBar from '../progressbar/ProgressBar'
import ImageSwiper from '../image-swiper/ImageSwiper'

import { getBackgrounds } from '../../actions/ContentActions'
import { storePostcard } from '../../actions/PostcardActions'


class BacgroundScreen extends Component {
  static contextTypes = {
    router: React.PropTypes.object
  }

  constructor(props) {
    super(props)
    this.state = {
      postcard: JSON.parse(localStorage.getItem('postcard'))
    }    
  }

  static defaultProps = {
    backgrounds: []
  }

  componentWillMount() {
    this.props.dispatch(getBackgrounds())
    let localPostcard = JSON.parse(localStorage.getItem('postcard'))
    localPostcard.thumb_path = ""
    localPostcard.short_link = ""
    localPostcard.origin_image = ""

    localStorage.setItem('postcard', JSON.stringify(localPostcard));      
  }

  handlePostcardStore = () => {
    const postcard = localStorage.getItem('postcard')
    this.props.dispatch(storePostcard(postcard)).then(() => {      
      this.context.router.push('share')
    })
  }

  handleBackgroundChange = (newValue) => {
    this.setState({
      postcard: {
        ...this.state.postcard,
        background: newValue
      }
    })

    let localPostcard = JSON.parse(localStorage.getItem('postcard'))
    localPostcard.background = newValue

    localStorage.setItem('postcard', JSON.stringify(localPostcard));    
  }

  render() {
    const { backgrounds, referer } = this.props 
    const { postcard } = this.state 

    return (
      <div style={{height: '100%'}}>
        <ProgressBar step="3" reverse={(referer.action !== "PUSH") ? 'reverse' : 'normal'}/>

        <ImageSwiper 
          images={backgrounds} 
          selected={postcard.background}
          onValueChanged={this.handleBackgroundChange}/>

        <div className="buttons-row">
          <BackButton title="Назад"/>
          <StepButton small={true} onNavigate={this.handlePostcardStore} title="Создать открытку" />
        </div>  
      </div>
    );
  }
}

export default connect((state) => ({
  backgrounds: state.backgrounds.data,
  referer: state.routing.locationBeforeTransitions
}))(BacgroundScreen)


// WEBPACK FOOTER //
// ./src/components/postcard/BackgroundScreen.js